module.exports = __webpack_public_path__ + "static/media/cc-logo.d84e6273.jpg";